import { SpeakerSimpleHigh } from '@phosphor-icons/react';

export default SpeakerSimpleHigh;
